import React, { useState, useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import { useQuoteContext } from "../../context-api/quote-context";
import { Link } from "react-router-dom";
import loading from "../../Assets/Images/loading/loading.svg";
import Results from "../../components/quote-components/Results";
import SaveQuote from "../../components/popups/SaveQuote";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Video from "../../components/Video";
import Faq from "../../components/universal-components/Faq";
import CallUsModal from "../../components/quote-components/CallUsModal";

const Prices = () => {
  const { closeNavbarMenu, isCallOpen, setIsCallOpen } = useNavContext();
  const [isLoading, setIsLoading] = useState(true);
  const [quote, setQuote] = useState([]);
  const [error, setError] = useState(false);
  const { numBedrooms, boilerType } = useQuoteContext();
  const [saveQuote, setSaveQuote] = useState(false);

  const showSaveQuote = () => {
    setTimeout(() => {
      setSaveQuote(true);
    }, 5000);
  };

  const fetchQuotes = async () => {
    const bedrooms = Number(numBedrooms);
    try {
      if (bedrooms < 3 && boilerType === "Combi") {
        const category = "catA";
        const url = `https://aquaheat-quotes.herokuapp.com/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
      if (bedrooms > 2 && bedrooms <= 4 && boilerType === "Combi") {
        const category = "catB";
        const url = `https://aquaheat-quotes.herokuapp.com/api/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
      if (bedrooms > 4 && boilerType === "Combi") {
        const category = "catC";
        const url = `https://aquaheat-quotes.herokuapp.com/api/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
      if (bedrooms < 3 && boilerType === "System") {
        const category = "catD";
        const url = `https://aquaheat-quotes.herokuapp.com/api/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
      if (bedrooms > 2 && bedrooms <= 4 && boilerType === "System") {
        const category = "catE";
        const url = `https://aquaheat-quotes.herokuapp.com/api/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
      if (bedrooms > 4 && boilerType === "System") {
        const category = "catF";
        const url = `https://aquaheat-quotes.herokuapp.com/api/v1/?category=${category}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          setIsLoading(false);
          setQuote(data.data);
          showSaveQuote();
        } else {
          setError(true);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchQuotes();
    // eslint-disable-next-line
  }, []);

  if (error) {
    return (
      <div>
        <h1>There was an error. Answer Questions Again</h1>
        <Link to="/question-one">Start Again</Link>
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className="section-wrapper">
        <div className="load-wrapper">
          <h1 className="title">Calculating Quotes</h1>
          <img className="spinner" src={loading} alt="" />
        </div>
      </div>
    );
  }
  return (
    <>
      <section
        className="price-section section-wrapper"
        onMouseOver={closeNavbarMenu}
      >
        <div className="price-header">
          <h1 className="price-title">Build Your AquaHeat Boiler Package</h1>
          <p clasName="price-subtitle">
            Every AquaHeat installation includes Gas Safe installation, a free
            system cleanse, recycling of your old boiler and more...
          </p>
        </div>
        <div className="price-section-body">
          {quote.map((item, index) => {
            const { name, img, desc, size, _id, price } = item;
            return (
              <Results
                key={index}
                name={name}
                img={img}
                desc={desc}
                size={size}
                id={_id}
                price={price}
              />
            );
          })}
        </div>
        <div className={saveQuote ? "save-quote_modal" : "hide"}>
          <SaveQuote setSaveQuote={setSaveQuote} />
        </div>
        <div className={isCallOpen ? "callus" : "hide"}>
          <CallUsModal setIsCallOpen={setIsCallOpen} />
        </div>
      </section>
      <HomeReviews />
      <Video />
      <Faq />
    </>
  );
};
export default Prices;
